"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getResellerName = void 0;
const getResellerName = () => localStorage.getItem('re');
exports.getResellerName = getResellerName;
